module.exports = __webpack_public_path__ + "static/media/me1.8c6552af.jpeg";